import { __extends } from "tslib";
import { exposeGetters } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';
var AddonsTheme = /** @class */ (function (_super) {
    __extends(AddonsTheme, _super);
    function AddonsTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AddonsTheme, "addonsTopBarItemHeight", {
        get: function () {
            return this.addonsTopBarHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarItemLineHeight", {
        get: function () {
            return this.addonsTopBarItemHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemHeight", {
        get: function () {
            return "calc(" + this.addonsUserAvatarSize + " + 2 * " + this.addonsTopBarAvatarItemOutline + ")";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemPaddingY", {
        get: function () {
            return this.addonsTopBarAvatarItemOutline;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemPaddingX", {
        get: function () {
            return this.addonsTopBarAvatarItemOutline;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemMarginY", {
        get: function () {
            return "-" + this.addonsTopBarAvatarItemOutline;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemMarginX", {
        get: function () {
            return "calc(-" + this.addonsTopBarAvatarItemOutline + " + " + this.addonsTopBarAvatarItemGap + ")";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarOrganizationsArrowWidth", {
        get: function () {
            return "calc(2 * " + this.addonsTopBarItemPaddingX + ")";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsLogoDividerBg", {
        get: function () {
            return this.addonsTopBarDividerBg;
        },
        enumerable: true,
        configurable: true
    });
    //#region TopBar
    AddonsTheme.addonsTopBarBg = '#fff';
    AddonsTheme.addonsTopBarShadow = '0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 8px 0 rgba(0, 0, 0, 0.1)';
    AddonsTheme.addonsTopBarDividerBg = '#dfdfdf';
    AddonsTheme.addonsTopBarDividerHeight = '30px';
    AddonsTheme.addonsTopBarDividerMarginX = '0px';
    AddonsTheme.addonsTopBarHeight = '50px';
    AddonsTheme.addonsTopBarItemPaddingY = '0px';
    AddonsTheme.addonsTopBarItemPaddingX = '10px';
    AddonsTheme.addonsTopBarItemMarginY = '0px';
    AddonsTheme.addonsTopBarItemMarginX = '0px';
    AddonsTheme.addonsTopBarAvatarItemOutline = '4px';
    AddonsTheme.addonsTopBarAvatarItemGap = '8px';
    AddonsTheme.addonsTopBarPaddingX = '15px';
    AddonsTheme.addonsTopBarPaddingY = '0';
    AddonsTheme.addonsTopBarMarginBottom = '20px';
    AddonsTheme.addonsTopBarItemIconGap = '4px';
    AddonsTheme.addonsTopBarIconColor = '#666';
    AddonsTheme.addonsTopBarItemBorderRadius = '0';
    AddonsTheme.addonsTopBarItemActionBackground = 'rgba(0, 0, 0, 0.06)';
    AddonsTheme.addonsTopBarMenuSeparatorMarginX = '12px';
    AddonsTheme.addonsTopBarMenuSeparatorMarginY = '4px';
    AddonsTheme.addonsTopBarMenuSeparatorColor = 'rgba(0, 0, 0, 0.05)';
    AddonsTheme.addonsTopBarMenuItemHoverBg = 'rgba(0, 0, 0, 0.05)';
    AddonsTheme.addonsTopBarMenuItemHoverColor = '#222';
    AddonsTheme.addonsTopBarMenuItemCommentColorHover = '#3C3C3C';
    AddonsTheme.addonsTopBarMenuItemPaddingX = '12px';
    //#endregion
    //#region Logotype
    AddonsTheme.addonsLogoColor = '#000';
    AddonsTheme.addonsLogoHoverColor = '#000';
    AddonsTheme.addonsLogoDividerHeight = '100%';
    AddonsTheme.addonsLogoDividerWidth = '1px';
    AddonsTheme.addonsLogoDividerMarginX = '15px';
    // public static addonsLogoWidgetPaddingX = '0';
    AddonsTheme.addonsLogoWidgetPaddingX = '10px';
    AddonsTheme.addonsLogoButtonHeight = '100%';
    AddonsTheme.addonsLogoButtonWidth = '20px';
    AddonsTheme.addonsLogoButtonMarginLeft = '4px';
    AddonsTheme.addonsLogoButtonActionBorderRadius = '0';
    AddonsTheme.addonsLogoButtonActionBackground = 'rgba(0, 0, 0, 0.06)';
    //#endregion
    //#region UserAvatar
    AddonsTheme.addonsUserAvatarSize = '32px';
    AddonsTheme.addonsUserAvatarBorderRadius = '100%';
    AddonsTheme.addonsUserAvatarBackground = 'transparent';
    AddonsTheme.addonsUserAvatarHoverBackground = '#222';
    AddonsTheme.addonsUserAvatarActiveBackground = '#222';
    AddonsTheme.addonsUserAvatarColor = '#222';
    AddonsTheme.addonsUserAvatarHoverColor = '#fff';
    AddonsTheme.addonsUserAvatarActiveColor = '#fff';
    return AddonsTheme;
}(/** @class */ (function () {
    function class_1() {
    }
    return class_1;
}())));
export { AddonsTheme };
export var REACT_UI_ADDONS_THEME_KEY = '__IS_REACT_UI_ADDONS_THEME__';
export var markAsAddonsTheme = function (theme) {
    var _a;
    return Object.create(theme, (_a = {},
        _a[REACT_UI_ADDONS_THEME_KEY] = {
            value: true,
            writable: false,
            enumerable: false,
            configurable: false,
        },
        _a));
};
export var isAddonsTheme = function (theme) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //@ts-ignore
    return theme[REACT_UI_ADDONS_THEME_KEY] === true;
};
export var AddonsThemeInternal = exposeGetters(AddonsTheme);
